import { render, staticRenderFns } from "./KpiDrilldownTable.vue?vue&type=template&id=226d95f8&scoped=true&lang=pug&"
import script from "./KpiDrilldownTable.vue?vue&type=script&lang=js&"
export * from "./KpiDrilldownTable.vue?vue&type=script&lang=js&"
import style0 from "./KpiDrilldownTable.vue?vue&type=style&index=0&id=226d95f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226d95f8",
  null
  
)

export default component.exports